var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 2.625H13.8125V0.5H10.625V2.625H6.375V0.5H3.1875V2.625H1.0625C0.476 2.625 0 3.101 0 3.6875V16.4375C0 17.024 0.476 17.5 1.0625 17.5H15.9375C16.524 17.5 17 17.024 17 16.4375V3.6875C17 3.101 16.524 2.625 15.9375 2.625ZM14.875 15.375H2.125V5.8125H14.875V15.375Z",
    fill: "#767B87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.9375H4.25V10.0625H6.375V7.9375Z",
    fill: "#767B87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 7.9375H7.4375V10.0625H9.5625V7.9375Z",
    fill: "#767B87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 11.125H4.25V13.25H6.375V11.125Z",
    fill: "#767B87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 11.125H7.4375V13.25H9.5625V11.125Z",
    fill: "#767B87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.9375H10.625V10.0625H12.75V7.9375Z",
    fill: "#767B87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.125H10.625V13.25H12.75V11.125Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/DatePickerIcon.b4c75c7d5ebe9774e5cbeaf8378167aa.svg";
export { ForwardRef as ReactComponent };